import type { Invoice } from '../types/invoice';
import type { SalesTransaction } from '../types/salesTransaction';

const amountsEqual = (a: string, b: string) =>
  Math.abs(parseFloat(a) - parseFloat(b)) < 0.0001;

/** Editable when DRAFT, or OPEN with no payments applied (balance = total_amount). */
export const canEditInvoice = (
  invoice: Pick<Invoice, 'status' | 'balance' | 'total_amount'>
): boolean => {
  if (invoice.status === 'DRAFT') return true;
  if (invoice.status === 'OPEN') {
    return amountsEqual(invoice.balance, invoice.total_amount);
  }
  return false;
};

/** Prefer backend actions; fallback when list row may lack updated actions. */
export const canEditSalesTransaction = (txn: SalesTransaction): boolean =>
  txn.available_actions.includes('edit') ||
  (txn.status === 'OPEN' && amountsEqual(txn.balance, txn.total_amount));
